import React, { useState, createContext, useEffect } from "react";

export const SideContext = createContext();

export const SideProvider = (props) => {
  const [sideIndex, setSideIndex] = useState("dashboard");

  useEffect(() => {
    console.log(`changed to ${sideIndex}`);
  }, [sideIndex]);

  return (
    <SideContext.Provider
      value={{
        sideIndex,
        setSideIndex,
      }}
    >
      {props.children}
    </SideContext.Provider>
  );
};
